/**
 *
 * vue3-snackbarを使った実装。plugins/vue3-snackbar, components/global/GlobalSnackbarが関連している。
 *
 */
export const useSnackbar = () => {
  const snackbarStore = useSnackbarStore()

  function snackbar(props: SnackbarProps) {
    snackbarStore.addMessage(props)
  }

  function snackbarMsg(msg: LangString) {
    snackbar({ message: msg, duration: 5000 })
  }

  function snackbarSuccess(msg: LangString) {
    snackbar({ message: msg, type: 'success', duration: 5000 })
  }

  function snackbarError(msg: LangString) {
    snackbar({ message: msg, type: 'error', duration: 5000 })
  }

  function closeAllSnackbars() {
    snackbarStore.clearAllMessage()
  }

  return {
    snackbar,
    snackbarMsg,
    snackbarSuccess,
    snackbarError,
    closeAllSnackbars,
  }
}
